export default "__VITE_ASSET__tg3gaiZH__"